import { createSlice } from "@reduxjs/toolkit";
import { fetchOccupancyInsights } from "../thunks/analyticsThunks";

const initialState = {
    data: null,
    isLoading: false,
    error: null,
    propertyNames: [],
  };

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchOccupancyInsights.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOccupancyInsights.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data?.data;
        const newPropertyNames = action.payload.data?.data?.propertyData.map(p => p.propertyName);
        const allPropertyNames = new Set([...state.propertyNames, ...newPropertyNames]);
        state.propertyNames = Array.from(allPropertyNames);

      })
      .addCase(fetchOccupancyInsights.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "An error occurred";
      });
  },
});

export default analyticsSlice.reducer;
